import * as api from '../../services/payConfig'

export const FETCH_USER_MERCHANTS= 'FETCH_USER_MERCHANTS';
export const FETCH_WECHATMERCHANTS= 'FETCH_WECHATMERCHANTS';
export const FETCH_ALIPAYMERCHANTS= 'FETCH_ALIPAYMERCHANTS';



export const fetchUserMerchants = (params, pagination, sort, extra) => {
    return {
        type: FETCH_USER_MERCHANTS,
        payload: {
            promise: api.findUserMerchants(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};


export const fetchWechatMerchants = (params, pagination, sort, extra) => {

    return {
        type: FETCH_WECHATMERCHANTS,
        payload: {
            promise: api.findWechatMerchants(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};
export const fetchAlipayMerchants = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ALIPAYMERCHANTS,
        payload: {
            promise: api.findAlipayMerchants(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/payConfig.js